<template>
  <div class="svg-edit">
    <div class="selector-container d-flex section-container" :class="{ dark: skinType }">
      <SectionTitle title="绘制svg" />
      <project-level-selector level-type="pds" @selectItem="selectItemListener" />
    </div>
    <wiring-diagram-edit :svg-id="pdsIdStr" />
  </div>
</template>
<script>
import ProjectLevelSelector from "@/components/utils/project-level-selector.vue";
import SectionTitle from "@/components/utils/section-title.vue";
import wiringDiagramEdit from "../components/wiringDiagramEdit.vue";

export default {
  components: {
    wiringDiagramEdit,
    SectionTitle,
    ProjectLevelSelector,
  },
  data() {
    return {
      pdsIdStr: "",
    };
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  created() {},
  methods: {
    selectItemListener(val) {
      console.log(val);
      if (val.oType === "pds") {
        this.pdsIdStr = val.IdStr;
      }
    },
  },
};
</script>
<style scoped></style>
